import { Box, Button, makeStyles, IconButton } from '@material-ui/core';
import { API } from 'aws-amplify';
import React, { FC, useState, useEffect, useRef } from 'react';
import AddIcon from '@material-ui/icons/Add';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import DeleteIcon from '@material-ui/icons/Delete';

const useStyles = makeStyles(() => ({
  root: {
    fontFamily: 'Archivo',
    fontWeight: 600
  },
  header: {
    display: 'flex',
    fontSize: '34px',
    lineHeight: 1.1,
    fontWeight: 600,
    marginBottom: '31px'
  },
  text: {
    fontSize: '18px',
    lineHeight: 1.5,
    fontWeight: 'bold'
  },
  subtext: {
    fontSize: '16px',
    lineHeight: 1.5,
    fontWeight: 400,
    color: '#616161'
  },
  addButton: {
    borderRadius: 43,
    width: '172px',
    height: '43px',
    fontSize: '14px',
    textTransform: 'none',
    margin: '60px 0px'
  },
  installedWrapper: {
    width: '100%',
    height: '321px',
    backgroundColor: '#EEEEEE',
    padding: '16px'
  },
  installedHeader: {
    fontSize: '13px',
    fontWeight: 600,
    color: '#9E9E9E'
  },
  fontListWrapper: {
    width: '100%',
    height: '270px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    overflow: 'auto',
    paddingTop: '10px'
  },
  fontButton: {
    display: 'flex',
    alignItems: 'center',
    height: '45px',
    paddingLeft: '10px',
    fontSize: '13px',
    borderRadius: '5px',
    backgroundColor: '#EEEEEE'
  },
  fontButtonInput: {
    width: '30%',
    height: '30px',
    padding: '0px 10px',
    border: 'none',
    outline: 'none',
    borderRadius: '5px'
  },
  fontButtonInputUrl: {
    marginLeft: '10px',
    paddingLeft: '15px',
    width: '70%',
    height: '30px',
    alignContent: 'center',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    border: 'none',
    outline: 'none',
    borderRadius: '5px'
  },
  fontEditInput: {
    border: 'none',
    outline: 'none',
    width: '35%',
    height: '25px',
    padding: '0px 10px',
    fontSize: '13px',
    borderRadius: '5px',
    alignContent: 'center'
  },
  fontEditdivUrl: {
    borderLeft: '2px solid black',
    marginLeft: '5px',
    paddingLeft: '15px',
    width: '65%',
    height: '25px',
    alignContent: 'center',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontSize: '13px'
  },
  fontWrapper: {
    display: 'flex',
    alignItems: 'center',
    height: '30px',
    margin: '10px 0px'
  },
  blankText: {
    fontSize: '14px',
    fontWeight: 500,
    color: '#757575'
  }
}));

const CustomFont: FC = () => {
  const classes = useStyles();
  const [fontData, setFontData] = useState({
    name: '',
    url: ''
  });
  const [uniqueArr, setUniqueArr] = useState([]);
  const [isAdd, setIsAdd] = useState(false);
  const newFontRef = useRef(null);

  useEffect(() => {
    async function onLoad() {
      try {
        const installedFonts = await API.get('iam-editor', '/fontlist', '');
        if (installedFonts.length !== 0) {
          const keys = Object.keys(installedFonts[0]);
          const hasNameAndUrl = keys.includes('name') && keys.includes('url');
          if (hasNameAndUrl) {
            setUniqueArr(installedFonts);
            localStorage.setItem('fontFiles', JSON.stringify(installedFonts));
          } else {
            alert(
              'You cannot use previous Upload Font files. Please use new feature FONT LINK URL.'
            );
            setUniqueArr([]);
            try {
              const response = await saveFont(uniqueArr);
            } catch (error) {
              console.log('error');
            }
          }
        }
      } catch (error) {
        console.log('error', error);
      }
    }
    onLoad();
  }, []);

  // const handleEdit = idx => {
  //   setEditingFontIndex(idx);
  // };

  const handleButtonClick = () => {
    setIsAdd(prev => !prev);
  };

  const handleChangeFont = e => {
    const { name, value } = e.target;

    if (value.includes("'") || value.includes('"') || value.includes('\\')) {
      return;
    }

    setFontData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  // const handleEditFontName = (event, index) => {
  //   const newUniqueArr = [...uniqueArr];
  //   newUniqueArr[index].name = event.target.value;
  //   setUniqueArr(newUniqueArr);
  // };

  // const onClickEditFont = async (e, idx) => {
  //   e.preventDefault();

  //   const { name, url } = uniqueArr[idx];
  //   if (name === '' || url === '') {
  //     alert('Please fill out the form');
  //     return;
  //   }

  //   const isNameExists = uniqueArr.some(
  //     (font, index) => index !== idx && font.name === name
  //   );
  //   if (isNameExists) {
  //     alert('The name already exists. Please choose a different name.');
  //     return;
  //   }
  //   try {
  //     const response = await saveFont(uniqueArr);
  //     if (response) {
  //       alert('Edit Successful');
  //       setEditingFontIndex(null);
  //     } else {
  //       alert('try again');
  //     }
  //   } catch (e) {
  //     console.log(e);
  //   }
  // };

  const onClickDeleteFont = async (e, idx) => {
    e.preventDefault();

    const confirmDelete = window.confirm(
      'Are you sure you want to delete this font?'
    );
    if (!confirmDelete) {
      return;
    }
    const newUniqueArr = uniqueArr.filter((_, index) => index !== idx);
    setUniqueArr(newUniqueArr);
    try {
      const response = await saveFont(newUniqueArr);
      if (response) {
        alert('Delete Successful');
      } else {
        alert('try again');
      }
    } catch (e) {
      console.log(e);
    }
  };

  const onClickSaveFont = async e => {
    e.preventDefault();

    if (fontData?.name !== '' && fontData?.url !== '') {
      const isNameExists = uniqueArr.some(font => font.name === fontData.name);
      if (isNameExists) {
        alert('The name already exists. Please choose a different name.');
        return;
      }

      if (!fontData?.url?.startsWith('https://braze')) {
        alert('Please use the Font URL from Braze Media Library');
        return;
      }

      const newUniqueArr = [...uniqueArr, fontData];
      setUniqueArr(newUniqueArr);

      try {
        const response = await saveFont(newUniqueArr);
        if (response) {
          alert('Save Successful');
          setFontData({ name: '', url: '' });
          setIsAdd(false);
          newFontRef.current.scrollIntoView({ behavior: 'smooth' });
        } else {
          alert('try again');
        }
      } catch (error) {
        console.log('error', error.message);
      }
    } else {
      alert('Please fill out the name and url');
      return;
    }
  };

  async function saveFont(uniqueArr) {
    try {
      const response = await API.patch('iam-editor', `/db/fontlist`, {
        body: {
          fontFiles: uniqueArr
        }
      });
      return true;
    } catch (e) {
      alert('please try again');
      return false;
    }
  }

  return (
    <div className={classes.root}>
      <Box>
        <h1 className={classes.header}>Custom font</h1>
        <p className={classes.text}>Embed font file URL</p>
        <p className={classes.subtext}>
          You can embed font file using URL through braze media library. Please
          check
          <a
            href={
              'https://metric-studio.notion.site/How-to-apply-custom-font-URL-48e6f59031d341c29c22aaf06213c8d4?pvs=4'
            }
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: 'inherit', marginLeft: '5px' }}
          >
            description
          </a>
          <p
            style={{
              fontWeight: 'bold',
              marginTop: '20px'
            }}
          >
            Please enter the correct Braze Media Library font URL
            <br />
            The font will not be applied and the built-in system font will be
            used instead
          </p>
        </p>
      </Box>
      <Box>
        {!isAdd ? (
          <Button
            variant="outlined"
            startIcon={<AddIcon />}
            color="primary"
            onClick={handleButtonClick}
            className={classes.addButton}
          >
            Add Custom Font
          </Button>
        ) : (
          <div
            style={{ padding: '60px 0px' }}
            onClick={e => {
              if (e.target === e.currentTarget) setIsAdd(false);
            }}
          >
            <div className={classes.fontButton}>
              <input
                type="text"
                value={fontData.name}
                name="name"
                onChange={handleChangeFont}
                autoFocus
                maxLength={25}
                className={classes.fontButtonInput}
                placeholder="Font Name"
              />
              <input
                type="text"
                value={fontData.url}
                name="url"
                onChange={handleChangeFont}
                className={classes.fontButtonInputUrl}
                placeholder="Font URL"
              />
              <IconButton color="primary" onClick={onClickSaveFont}>
                <AddCircleIcon />
              </IconButton>
            </div>
          </div>
        )}
        <div className={classes.installedWrapper}>
          <p className={classes.installedHeader}>Installed fonts</p>
          <div className={classes.fontListWrapper}>
            {uniqueArr.length > 0 ? (
              uniqueArr.map((font, idx) => (
                <div
                  key={idx}
                  ref={idx === uniqueArr.length - 1 ? newFontRef : null}
                  style={{
                    width: '100%'
                  }}
                >
                  {/* {editingFontIndex === idx ? (
                    <>
                      <div className={classes.fontWrapper}>
                        <input
                          type="text"
                          value={font?.name}
                          name="name"
                          onChange={e => handleEditFontName(e, idx)}
                          autoFocus
                          maxLength={25}
                          className={classes.fontEditInput}
                        />
                        <div className={classes.fontEditdivUrl}>
                          {font?.url}
                        </div>
                        <IconButton
                          color="primary"
                          onClick={e => onClickEditFont(e, idx)}
                        >
                          <CheckIcon />
                        </IconButton>
                        <IconButton
                          color="primary"
                          onClick={() => setEditingFontIndex(null)}
                        >
                          <CloseIcon />
                        </IconButton>
                      </div>
                    </>
                  ) : ( */}
                  <>
                    <div className={classes.fontWrapper}>
                      <div className={classes.fontEditInput}>{font?.name}</div>
                      <div className={classes.fontEditdivUrl}>{font?.url}</div>
                      {/* <IconButton
                          color="primary"
                          onClick={() => handleEdit(idx)}
                          disabled={isAdd}
                        >
                          <EditIcon />
                        </IconButton> */}
                      <IconButton color="primary" disabled={isAdd}>
                        <DeleteIcon onClick={e => onClickDeleteFont(e, idx)} />
                      </IconButton>
                    </div>
                  </>
                  {/* )} */}
                </div>
              ))
            ) : (
              <div
                style={{
                  display: 'flex',
                  margin: 'auto'
                }}
              >
                <p className={classes.blankText}>
                  There is no installed custom fonts
                </p>
              </div>
            )}
          </div>
        </div>
      </Box>
    </div>
  );
};

export default CustomFont;
